
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.83 10.29L13.71 8.17002C13.32 7.78002 13.32 7.15002 13.71 6.76002C14.1 6.37002 14.73 6.37002 15.12 6.76002L16.53 8.17002L20.07 4.63002C20.46 4.24002 21.09 4.24002 21.48 4.63002C21.87 5.02002 21.87 5.65002 21.48 6.04002L17.24 10.28C16.85 10.68 16.22 10.68 15.83 10.29ZM10 7.00002H3C2.45 7.00002 2 7.45002 2 8.00002C2 8.55002 2.45 9.00002 3 9.00002H10C10.55 9.00002 11 8.55002 11 8.00002C11 7.45002 10.55 7.00002 10 7.00002ZM20.29 12.71C19.9 12.32 19.27 12.32 18.88 12.71L17 14.59L15.12 12.71C14.73 12.32 14.1 12.32 13.71 12.71C13.32 13.1 13.32 13.73 13.71 14.12L15.59 16L13.71 17.88C13.32 18.27 13.32 18.9 13.71 19.29C14.1 19.68 14.73 19.68 15.12 19.29L17 17.41L18.88 19.29C19.27 19.68 19.9 19.68 20.29 19.29C20.68 18.9 20.68 18.27 20.29 17.88L18.41 16L20.29 14.12C20.68 13.73 20.68 13.1 20.29 12.71ZM10 15H3C2.45 15 2 15.45 2 16C2 16.55 2.45 17 3 17H10C10.55 17 11 16.55 11 16C11 15.45 10.55 15 10 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-rule`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRule

    ```js
    <b-new-b-icon-rule />
    ```
</docs>


